export const IT = {
  //AvpHeader
  AvpHeaderAvpManager: "GESTIONE AVP",
  AvpHeaderContent: "CONTENUTI",
  AvpHeaderUsers: "GESTIONE UTENTI",
  AvpHeaderSystem: "SISTEMA",

  //AvpSaveFooter
  AvpSaveFooterTitle: "Cliccando su Salva",
  AvpSaveFooterSubtitle: "confermi le modifiche apportate",
  AvpSaveFooterSave: "SALVA",
  AvpSaveFooterReset: "ANNULLA",
  // DashboardScreen

  DashboardTitle: "Dashboard",

  //PasswordRecoverScreen

  PasswordRecoverTitle: "Assistente Virtuale Personalizzabile",
  PasswordRecoverSubtitle: "Content Management System",
  PasswordRecoverFormTitle: "Reset password",
  PasswordRecoverFormPassword: "Password",
  PasswordRecoverFormRepeatPassword: "Ripeti password",
  PasswordRecoverFormButtonConfirm: "CONFERMA",
  PasswordRecoverDialog: "La tua password è stata aggiornata.",
  PasswordRecoverDialogConfirm: "OK",

  // LoginScreen

  LoginHeaderTitle: "Assistente Virtuale Personalizzabile",
  LoginHeaderSubtitle: "Content Management System",
  LoginFormTitle: "Accedi all'area riservata",
  LoginFormLableUsername: "Username",
  LoginFormLablePassword: "Password",
  LoginFormLablePasswordDimenticata: "Hai dimenticato la password?",
  LoginFormButtonLogin: "LOGIN",
  LoginDialog:
    "Ti è stata inviata un'email con le istruzioni per il recupero password",
  LoginDialogConfirm: "OK",

  //GestioneAvpScreen

  AvpListGraphDescription: "Descrizione",
  AvpListGraphCodAsset: "Codice asset",
  AvpListGraphTimeout: "Timeout",
  AvpListGraphNInstance: "Num. istanze",
  AvpListIconGraphic: "grafico",
  AvpListIconCloneAVP: "clona AVP",
  AvpListIconModify: "modifica",
  AvpListIconDelete: "elimina",
  AvpListIconInstance: "instance",
  AvpListAlertSuccess: "Modifica effettuata con successo.",
  AvpListAlertError: "Si è verificato un errore durante la modifica...",
  AvpListTitle: "Crea o modifica un Assistente Virtuale Personalizzato",
  AvpListTitleAvp: "AVP",
  AvpListButtonAdd: "CREA NUOVO AVP",

  AvpListDialogClone: "Clonare l'AVP selezionato?",
  AvpListDialogConfirmClone: "SI",
  AvpListDialogResetClone: "NO",

  AvpListDialogDelete: "Eliminare l'AVP selezionato?",
  AvpListDialogConfirmDelete: "SI",
  AvpListDialogResetDelete: "NO",

  //GestioneAvpDetailScreen

  AvpDetailbreadCrumb1: "Gestione AVP",
  AvpDetailbreadCrumb2: "Crea/Modifica AVP",
  AvpDetailAlertSuccess: "Modifica effettuata con successo.",
  AvpDetailAlertError: "Si è verificato un errore durante la modifica...",
  AvpDetailTitle: "Dati AVP",
  AvpDetailFormDesc: "Descrizione",
  AvpDetailFormCodeAsset: "Codice asset",
  AvpDetailFormTimeout: "Timeout",
  AvpDetailFormNumberIstance: "Istanze concorrenti",
  AvpDetailLanguageTitle: "Lingue",
  AvpDetailButtonToGraph: "GRAFO",

  //NewGraphScreen

  AvpGraphDetailbreadCrumb1: "Gestione AVP",
  AvpGraphDetailbreadCrumb2: "Crea/Modifica AVP",
  AvpGraphDetailbreadCrumb3: "Grafo AVP",
  AvpGraphDetailAlertSuccess: "Modifica effettuata con successo.",
  AvpGraphDetailAlertError: "Si è verificato un errore durante la modifica...",

  //GraphEditComponent

  AvpGraphNodeCloseWindows: "CHIUDI FINESTRA",
  AvpGraphNodeTabProperty: "Proprietà",
  AvpGraphNodeFormName: "Nome",
  AvpGraphNodeFormStartType: "Tipo avvio",
  AvpGraphNodeFormAvatar: "Avatar",
  AvpGraphNodeFormAvatarPosX: "Pos X(%)",
  AvpGraphNodeFormAvatarPosY: "Pos Y(%)",
  AvpGraphNodeFormAvatarDimW: "Dim W(%)",
  AvpGraphNodeFormAvatarDimH: "Dim H(%)",
  AvpGraphNodeFormAvatarZIndex: "Z-Index",
  AvpGraphNodeFormContenuti: "Contenuti",
  AvpGraphNodeFormContenutiPosX: "Pos X(%)",
  AvpGraphNodeFormContenutiPosY: "Pos Y(%)",
  AvpGraphNodeFormContenutiDimW: "Dim W(%)",
  AvpGraphNodeFormContenutiDimH: "Dim H(%)",
  AvpGraphNodeFormContenutiZindex: "Z-index",
  AvpGraphNodeFormExsternalApi: "Api esterna",
  AvpGraphNodeFormFlagGoBack: "Flag Go Back",
  AvpGraphNodeFormAgent: "Agent",
  AvpGraphNodeFormDeleteButton: "elimina",
  AvpGraphNodeFormButtonSelect: "SELEZIONA",
  AvpGraphNodeFormLoadingFileAvatar: "Loading File Avatar",
  AvpGraphNodeFormAvatarType: "Tipo avatar",
  AvpGraphNodeFormAvatarTypeFirstOption: "Selezionare...",
  AvpGraphNodeFormSaveButton: "SALVA",
  AvpGraphNodeFormResetButton: "ANNULLA",

  //AvpNodeContentArcsSection

  AvpNodeContentArcsColumnsText: "Testo",
  AvpNodeContentArcsColumnsEndNode: "Nodo End",
  AvpNodeContentArcsButtonEdit: "modifica",
  AvpNodeContentArcsButtonDelete: "elimina",
  AvpNodeContentArcsButtonMoveUp: "muovi sopra",
  AvpNodeContentArcsButtonMoveDown: "muovi sotto",
  AvpNodeContentArcsArcTitle: "Archi",
  AvpNodeContentArcsButtonNew: "NUOVO ARCO",
  AvpNodeContentArcsAlertDelete: "Impossibile eliminare l'arco dal nodo START",
  AvpNodeContentArcsDialogDelete: "Eliminare l'arco selezionato?",
  AvpNodeContentArcsDialogConfirm: "SI",

  //AvpNodeContentPlaylistSection
  AvpNodeContentPlaylistColumnsTypr: "Tipo",
  AvpNodeContentPlaylistColumnsName: "Nome",
  AvpNodeContentPlaylistColumnsDuration: "Durata",
  AvpNodeContentPlaylistButtonEdit: "modifica",
  AvpNodeContentPlaylistButtonDelete: "elimina",
  AvpNodeContentPlaylistButtonMoveUp: "muovi sopra",
  AvpNodeContentPlaylistButtonMoveDown: "muovi sotto",
  AvpNodeContentPlaylistTitle: "Playlist",
  AvpNodeContentPlaylistButtonNewFile: "NUOVO FILE",
  AvpNodeContentPlaylistDialog: "Eliminare il file selezionato?",
  AvpNodeContentPlaylistDialogDecline: "NO",
  AvpNodeContentPlaylistDialogConfirm: "SI",

  //NewGestioneArcoScreen

  NewGestioneArcoBreadcrumb1: "Gestione AVP",
  NewGestioneArcoBreadcrumb2: "Crea/Modifica AVP",
  NewGestioneArcoBreadcrumb3: "Grafo AVP",
  NewGestioneArcoBreadcrumb4: "Arco",
  NewGestioneArcoAlertSuccess: " Modifica effettuata con successo.",
  NewGestioneArcoAlertError: "Si è verificato un errore durante la modifica...",
  NewGestioneArcoTitle: "Gestione Arco",
  NewGestioneArcoFormStartNode: "Nodo start",
  NewGestioneArcoFormEndNode: "Nodo End",
  NewGestioneArcoTextArc:
    "Testo (scelta visualizzata sull’interfaccia interattiva)",
  NewGestioneArcoFormCheckboxNotActive: "Non attivo",
  NewGestioneArcoCheckboxResetSession: "Reset della Sessione",
  ANewGestioneArcoCheckboxSkipToNextNode: "Esegui prossimo nodo",

  //GestioneAvpContentPlaylistFileScreen
  GestioneAvpContentPlaylistFileBreadcrumb1: "Gestione AVP",
  GestioneAvpContentPlaylistFileBreadcrumb2: "Crea/Modifica AVP",
  GestioneAvpContentPlaylistFileBreadcrumb3: "Crea/Modifica AVP",
  GestioneAvpContentPlaylistFileBreadcrumb4: "Playlist File",
  GestioneAvpContentPlaylistFileAlertSucess:
    "Modifica effettuata con successo.",
  GestioneAvpContentPlaylistFileAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneAvpContentPlaylistFileFormTitle: "Gestione Playlist File",
  GestioneAvpContentPlaylistFileFormIdPlaylist: "ID Playlist",
  GestioneAvpContentPlaylistFileFormFile: "File",
  GestioneAvpContentPlaylistFileFormDescription: "Descrizione",
  GestioneAvpContentPlaylistFileFormUrl: "Url",
  GestioneAvpContentPlaylistFileFormDuration: "Durata visualizzazione",
  GestioneAvpContentPlaylistFileFormSettings: "Settings",
  GestioneAvpContentPlaylistFileCheckboxLoop: "Loop",
  GestioneAvpContentPlaylistFileCheckboxRestartPlaylist: "Restart playlist",

  // GestioneAvpScreen

  GestioneAvpIstanceBreadcrumb1: "Gestione AVP",
  GestioneAvpIstanceBreadcrumb2: "AVP",
  GestioneAvpIstanceBreadcrumb3: "Istanze",
  GestioneAvpInstancceDialogTitle: "Conferma clonazione",
  GestioneAvpIstanceColumnUser: "Utente",
  GestioneAvpIstanceColumnDurSession: "Dur. Sessione",
  GestioneAvpIstanceColumnQRcode: "QR Code",
  GestioneAvpIstanceColumnPIN: "PIN",
  GestioneAvpIstanceColumnTypeInstance: "Tipo istanza",
  GestioneAvpIstanceImgEdit: "modifica",
  GestioneAvpIstanceImgDelete: "elimina",
  GestioneAvpIstanceImgQrCode: "QR Code",
  GestioneAvpIstanceImgPreview: "anteprima",
  GestioneAvpIstanceImgPreviewInteraction: "anteprima con interazioni",
  GestioneAvpIstanceAlertSuccess: "Modifica effettuata con successo.",
  GestioneAvpIstanceAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneAvpIstanceTitle:
    "Gestisci le istanze dell’Assistente Virtuale Personalizzato",
  GestioneAvpIstanceFormIstance: "istanze",
  GestioneAvpIstanceFormCreateIstance: "CREA ISTANZA",

  GestioneAvpIstanceAlertTitle: "Eliminare l'istanza selezionata?",
  GestioneAvpIstanceAlertDelete: "Eliminare l'istanza selezionata?",
  GestioneAvpIstanceAlertConfirm: "SI",
  GestioneAvpIstanceAlertUndo: "NO",

  // GestioneAvpIstanzeDetailScreen

  GestioneAvpIstanzeDetailBreadcrumb1: "Gestione AVP",
  GestioneAvpIstanzeDetailBreadcrumb2: "AVP",
  GestioneAvpIstanzeDetailBreadcrumb3: "Istanze",
  GestioneAvpIstanzeDetailBreadcrumb4: "Modifica Istanza",
  GestioneAvpIstanzeDetailAlertSuccess: "Modifica effettuata con successo.",
  GestioneAvpIstanzeDetailAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneAvpIstanzeDetailTitle: "Dati Istanza AVP",
  GestioneAvpIstanzeDetailUser: "Utente",
  GestioneAvpIstanzeDetailIstanceType: "Tipo Istanza",
  GestioneAvpIstanzeDetailIstanceOrientation: "Orientamento Istanza",
  GestioneAvpIstanzeDetailOptionOrizzontal: "Orizzontale",
  GestioneAvpIstanzeDetailOptionVeritcal: "Verticale",
  GestioneAvpIstanzeDetailDurationSession: "Durata sessione",
  GestioneAvpIstanzeDetailPIN: "PIN",
  GestioneAvpIstanzeDetailBlur: "Sfocatura",
  GestioneAvpIstanzeDetailQRcode: "QR Code",
  GestioneAvpIstanzeDetailText: "Testo",
  GestioneAvpIstanzeDetailPreset: "Preset",
  GestioneAvpIstanzeDetailStyles: "Stili",
  GestioneAvpIstanzeDetailAlign: "Allineamento",
  GestioneAvpIstanzeDetailDimension: "Dimensioni",

  // GestioneUtentiScreen

  GestioneUtentiBreadcrumb1: "Gestione Utenti",
  GestioneUtentiColumnName: "Nome",
  GestioneUtentiColumnSurname: "Cognome",
  GestioneUtentiColumnEmail: "Email",
  GestioneUtentiColumnTel: "Telefono",
  GestioneUtentiColumnUsername: "Username",
  GestioneUtentiImgEdit: "modifica",
  GestioneUtentiImgDelete: "elimina",
  GestioneUtentiImgRestore: "ripristina",
  GestioneUtentiAlertSuccess: " Modifica effettuata con successo.",
  GestioneUtentiAlertError: " Si è verificato un errore durante la modifica...",
  GestioneUtentiTabUser: "Utenti",
  GestioneUtentiTabGroup: "Gruppi",
  GestioneUtentiMainTitle: "Crea o modifica un utente",
  GestioneUtentiUserTitle: "Utenti",
  GestioneUtentiButtonNew: "CREA NUOVO UTENTE",
  GestioneUtentiState: "Stato",
  GestioneUtentiOptionActive: "Attivi",
  GestioneUtentiOptionNotActive: "Non attivi",
  GestioneUtentiDialogDisableUser: "Vuoi disabilitare l'utente selezionato?",
  GestioneUtentiDialogConfirm: "SI",
  GestioneUtentiDialogUndo: "NO",

  // GestioneUtenteDetailScreen
  GestioneUtenteDetailBreadcrumb1: "Gestione Utenti",
  GestioneUtenteDetailBreadcrumb2: "Crea/Modifica Utente",
  GestioneUtenteDetailAlertSucces: "Modifica effettuata con successo.",
  GestioneUtenteDetailAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneUtenteDetailTitle: "Gestione Utente",
  GestioneUtenteDetailName: "Nome",
  GestioneUtenteDetailSurname: "Cognome",
  GestioneUtenteDetailEmail: "Email",
  GestioneUtenteDetailTel: "Telefono",
  GestioneUtenteDetailUsername: "Username",
  GestioneUtenteDetailPassword: "Password",
  GestioneUtenteDetailGroupTitle: "Gruppo",

  // GestioneGruppiUtenteScreen
  GestioneGruppiUtenteBreadcrumb1: "Gestione Utenti",
  GestioneGruppiUtenteBreadcrumb2: "Gestione Gruppi",
  GestioneGruppiUtenteColumnDesc: "Descrizione",
  GestioneGruppiUtenteColumnBillingTo: "Fatturazione",
  GestioneGruppiUtenteColumnRifAmm: "Rif. Ammin.",
  GestioneGruppiUtenteColumnRifAmmMail: "Rif. Ammin. Email",
  GestioneGruppiUtenteColumnRifAmmTel: "Rif. Ammin. Tel",
  GestioneGruppiUtenteImgEdit: "modifica",
  GestioneGruppiUtenteImgDelete: "elimina",
  GestioneGruppiUtenteImgRestore: "ripristina",
  GestioneGruppiUtenteAlertSuccess: "Modifica effettuata con successo.",
  GestioneGruppiUtenteAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneGruppiUtenteUserTab: "Utenti",
  GestioneGruppiUtenteGroupTab: "Gruppi",
  GestioneGruppiUtenteTitle: "Crea o modifica un gruppo",
  GestioneGruppiUtenteSubTitle: "Gruppi utente",
  GestioneGruppiUtenteButtonNew: "CREA NUOVO GRUPPO UTENTE",
  GestioneGruppiUtenteState: "Stato",
  GestioneGruppiUtenteOptionActive: "Attivi",
  GestioneGruppiUtenteOptionNotActive: "Non attivi",
  GestioneGruppiUtenteDialogTitle: "Conferma disabilitazione",
  GestioneGruppiUtenteDialogText: "Vuoi disabilitare il gruppo selezionato?",
  GestioneGruppiUtenteDialogConfirm: "SI",
  GestioneGruppiUtenteDialogUndo: "NO",

  // GestioneGruppoUtenteDetailScreen

  GestioneGruppoUtenteDetailBreadcrumb1: "Gestione Utenti",
  GestioneGruppoUtenteDetailBreadcrumb2: "Gestione Gruppi",
  GestioneGruppoUtenteDetailBreadcrumb3: "Crea/Modifica Gruppo",
  GestioneGruppoUtenteDetailAlertSuccess: "Modifica effettuata con successo.",
  GestioneGruppoUtenteDetailAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneGruppoUtenteDetailTitle: "Gestione Gruppo Utente",
  GestioneGruppoUtenteDetailDescription: "Descrizione",
  GestioneGruppoUtenteDetailIDBulling: "ID Fatturazione",
  GestioneGruppoUtenteDetailRifAmministrative: "Rif. Amministrativo",
  GestioneGruppoUtenteDetailRifAmmEmail: "Rif. Ammin. Email",
  GestioneGruppoUtenteDetailRifAmmTel: "Rif. Ammin. Telefono",

  // GestioneContenutiScreen

  GestioneContenutiColumnDesc: "Descrizione",
  GestioneContenutiColumnType: "Tipo",
  GestioneContenutiColumnFile: "File",
  GestioneContenutiColumnFolder: "Cartella",
  GestioneContenutiPageTitle: "Gestisci i contenuti",
  GestioneContenutiPageSubtitle: "Contenuti",
  GestioneContenutiImgPreview: "anteprima",
  GestioneContenutiImgEdit: "modifica",
  GestioneContenutiImgDelete: "elimina",
  GestioneContenutiAlertSuccess: "Modifica effettuata con successo.",
  GestioneContenutiAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneContenutiButtonGoToAgent: "CONTENUTI AGENT",
  GestioneContenutiCreateAvatar: "CREA AVATAR",
  GestioneContenutiNewContent: "CREA NUOVO",
  GestioneContenutiTitle: "Tipo Contenuto",
  GestioneContenutiOptionAll: "Tutti",
  GestioneContenutiSearchLabel: "Testo di ricerca",
  GestioneContenutiButtonSearch: "CERCA",
  GestioneContenutiDialogTitle: "Conferma eliminazione",
  GestioneContenutiDialogDeleteText: "Eliminare il contenuto selezionato?",
  GestioneContenutiDialogDeleteFolder:
    "Eliminare la cartella selezionata e tutti i suoi contenuti?",
  GestioneContenutiDialogDeleteTrash:
    "Svuotare il cestino ed eliminare tutto il contenuto?",
  GestioneContenutiDialogConfirm: "SI",
  GestioneContenutiDialogUndo: "NO",

  // GestioneContenutiPickScreen

  GestioneContenutiPickBreadcrumb1: "Gestione AVP",
  GestioneContenutiPickBreadcrumb2: "Crea/Modifica AVP",
  GestioneContenutiPickBreadcrumb3: "Grafo AVP",
  GestioneContenutiPickBreadcrumb4: "Selezione contenuti",
  GestioneContenutiPickPageTitle: "Gestisci i contenuti",
  GestioneContenutiPickTitleAddToPlaylist:
    "Associa un contenuto multimediale alla playlist del nodo",
  GestioneContenutiPickTitleAddToArc:
    "Associa un'immagine all'arco selezionato",
  GestioneContenutiPickTitleAddToNode: "Associa un Avatar al nodo selezionato",
  GestioneContenutiPickTitleAddToLoadingNode:
    "Associa immagine di loading al nodo selezionato",
  GestioneContenutiPickCreateAgent: "Seleziona Immagine nuovo",
  GestioneContenutiPickColumnName: "Nome",
  GestioneContenutiPickColumnType: "Tipo",
  GestioneContenutiPickColumnFile: "File",
  GestioneContenutiPickColumnFolder: "Cartella",
  GestioneContenutiPickImgDelete: "elimina",
  GestioneContenutiPickImgEdit: "modifca",
  GestioneContenutiPickImgAdd: "aggiungi",
  GestioneContenutiPickImgPreview: "preview",
  GestioneContenutiPickAlertSuccess: "Modifica effettuata con successo.",
  GestioneContenutiPickAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneContenutiPickSubtitle: "Contenuti",
  GestioneContenutiPickButtonNew: "CREA NUOVO",
  GestioneContenutiPickContentType: "Tipo Contenuto",
  GestioneContenutiPickOptionAll: "Tutti",
  GestioneContenutiPickSearchText: "Testo di ricerca",
  GestioneContenutiPickDialogTitle: "Conferma eliminazione",
  GestioneContenutiPickDialogText: "Eliminare il contenuto selezionato?",
  GestioneContenutiPickDialogConfirm: "SI",
  GestioneContenutiPickDialogUndo: "NO",

  // GestioneContenutiFileScreen

  GestioneContenutiFileBreadcrumb1: "Gestione Contenuti",
  GestioneContenutiFileBreadcrumb2: "Crea/Modifica File",
  GestioneContenutiFileDialogSuccess: "Modifica effettuata con successo.",
  GestioneContenutiFileDialogError:
    "Si è verificato un errore durante la modifica...",
  GestioneContenutiFileTitle: "Gestione File",
  GestioneContenutiFileName: "Nome",
  GestioneContenutiFileNameFile: "Nome file",
  GestioneContenutiFileContentType: "Tipo Contenuto",
  GestioneContenutiFileOptionChoose: "Selezionare...",
  GestioneContenutiFileUploadFile: "Upload file",
  GestioneContenutiFileFatherFolder: "Cartella padre",

  // GestioneContenutiTree

  GestioneContenutiTreeImgAdd: "aggiungi",
  GestioneContenutiTreeImgEdit: "modifica",
  GestioneContenutiTreeImgDelete: "elimina",
  GestioneContenutiTreeImgUndo: "annulla",
  GestioneContenutiTreeImgDel: "cancella",

  // GestioneContenutiAvatarScreen
  GestioneContenutiAvatarBreadcrumb1: "Gestione Contenuti",
  GestioneContenutiAvatarBreadcrumb2: "Crea Avatar",
  GestioneContenutiAvatarAlertSucces: "Modifica effettuata con successo.",
  GestioneContenutiAvatarAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneContenutiAvatarTitle: "Gestione Avatar",
  ccccc: "Seleziona file da animare",
  GestioneContenutiAvatarButtonFile: "SELEZIONA",
  GestioneContenutiAvatarName: "Nome",
  GestioneContenutiAvatarGender: "Genere",
  GestioneContenutiAvatarOptionSelection: "Selezionare...",
  GestioneContenutiAvatarLang: "Lingua",
  GestioneContenutiAvatarVoice: "Voce",
  GestioneContenutiAvatarText: "Testo",
  GestioneContenutiAvatarSubtitle: "Sottotitoli",
  GestioneContenutiAvatarFooterTitle: "Cliccando su Salva",
  GestioneContenutiAvatarFooterSubtitle: "confermi le modifiche apportate",
  GestioneContenutiAvatarFooterSaveContinue: "SALVA E CHIUDI",
  GestioneContenutiAvatarFooterSaveClose: "SALVA E CONTINUA",
  GestioneContenutiAvatarFooterUndo: "ANNULLA",

  // GestioneAgentAIScreen
  GestioneAgentAIAlertErrorAddFile: "File non valido",
  GestioneAgentAIBreadcrumb1: "Gestione Contenuti",
  GestioneAgentAIBreadcrumb2: "Crea Agent",
  GestioneAgentAIAlertSuccess: "Modifica effettuata con successo.",
  GestioneAgentAIAlertError: "Si è verificato un errore durante la modifica...",
  GestioneAgentAITitleCreate: "Creazione agent",
  GestioneAgentAITitleEdit: "Modifica Agent",
  GestioneAgentAIName: "Nome",
  GestioneAgentAIGreetingsMessage: "Messaggio Benvenuto",
  GestioneAgentAILLMmodel: "Modello LLM",
  GestioneAgentAIButtonOpenChangeLanguge: "Cambia Lingua",
  GestioneAgentAIAgentVoice: "Voce Agent",
  GestioneAgentAIGender: "Genere",

  GestioneAgentAIOptionSelect: "Selezionare...",
  GestioneAgentAILang: "Lingua",
  GestioneAgentAIVoice: "Voce",

  GestioneAgentAIKnowladgeBase: "Knowledge Base",
  GestioneAgentAIKnowladgeBaseString: "Informazioni di testo da fornire",
  GestioneAgentAIAlertLimitDocument: "5 file massimo",
  GestioneAgentAIImgDelete: "elimina",
  GestioneAgentAIAgentImage: "Immagine Agent",
  GestioneAgentAIImageFile: "Immagine File:",
  GestioneAgentAIButtonSelect: "SELEZIONA",
  GestioneAgentFlagSizeImage: "Foto Dimensione Completa",

  GestioneAgentAIButtonSave: "SALVA",
  GestioneAgentAIButtonUndo: "ANNULLA",

  // GestioneAgentListScreen
  GestioneAgentListBreadcrumb1: "Gestione Agents",
  GestioneAgentListPageTitle: "Gestisci i contenuti Agents",
  GestioneAgentListColumnDesc: "Descrizione",
  GestioneAgentListColumnStatus: "Status",
  GestioneAgentListStatusDone: "Attivo",
  GestioneAgentListStatusError: "Errore",
  GestioneAgentListStatusLoading: "Working",
  GestioneAgentListImgEdit: "modifica",
  GestioneAgentListImgDelete: "elimina",
  GestioneAgentListImgAdd: "aggiungi",
  GestioneAgentListAlertSuccess: "Modifica effettuata con successo.",
  GestioneAgentListAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneAgentListButtonNew: "CREA AGENT",
  GestioneAgentListDialogTitle: "Eliminare il contenuto selezionato?",
  GestioneAgentListDialogConfirm: "SI",
  GestioneAgentListDialogUndo: "NO",

  // GestioneContenutiFolder

  GestioneContenutiFolderBreadcrumb1: "Gestione Contenuti",
  GestioneContenutiFolderBreadcrumb2: "Crea/Modifica Cartella",
  GestioneContenutiFolderAlertSuccess: "Modifica effettuata con successo.",
  GestioneContenutiFolderAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneContenutiFolderMnageFolder: "Gestione Cartella",
  GestioneContenutiFolderDesc: "Descrizione",
  GestioneContenutiFolderFatherFolder: "Cartella padre",

  // GestioneSistemaScreen
  GestioneSistemaBreadcrumb1: "Gestione Sistema",
  GestioneSistemaColumnID: "ID",
  GestioneSistemaColumnKey: "Chiave",
  GestioneSistemaColumnValue: "Valore",
  GestioneSistemaColumnSettingGroup: "Gruppo",
  GestioneSistemaImgEdit: "modifica",
  GestioneSistemaImgDelete: "elimina",
  GestioneSistemaImgRestore: "ripristina",
  GestioneSistemaAlertSucess: "Modifica effettuata con successo.",
  GestioneSistemaAlertError: "Si è verificato un errore durante la modifica...",
  GestioneSistemaTabSetting: "Settings",
  GestioneSistemaTabLang: "Lingue",
  GestioneSistemaTitle: "Crea o modifica le impostazioni di sistema",
  GestioneSistemaSubtitle: "Impostazioni",
  GestioneSistemaButtonNew: "CREA NUOVA VOCE",
  GestioneSistemaDialogTitle: " Vuoi eliminare la voce selezionata?",
  GestioneSistemaDialogConfirm: "SI",
  GestioneSistemaDialogUndo: "NO",

  // GestioneLingueScreen

  GestioneLingueBreadcrumb1: "Sistema",
  GestioneLingueBreadcrumb2: "Lingue",
  GestioneLingueColumnCodLang: "Codice Lingua",
  GestioneLingueColumnDesc: "Descrizione",
  GestioneLingueImgEdit: "modifica",
  GestioneLingueDialogSuccess: "Modifica effettuata con successo.",
  GestioneLingueDialogError: "Si è verificato un errore durante la modifica...",
  GestioneLingueTabSystem: "Sistema",
  GestioneLingueTabLang: "Lingue",
  GestioneLingueTitle: "Crea o modifica una lingua",
  GestioneLingueSubtitle: "Lingue",
  GestioneLingueButtonNew: "CREA NUOVA LINGUA",

  // GestioneLingueDetailScreen
  GestioneLingueDetailBreadcrumb1: "Sistema",
  GestioneLingueDetailBreadcrumb2: "Gestione Lingue",
  GestioneLingueDetailAlertSucess: "Modifica effettuata con successo.",
  GestioneLingueDetailAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneLingueDetailTitle: "Gestione Lingua",
  GestioneLingueDetailCodLang: " Codice Lingua",
  GestioneLingueDetailDesc: "Descrizione",

  // GestioneSistemaDetailScreen
  GestioneSistemaDetailBreadcrumb1: "Gestione Sistema",
  GestioneSistemaDetailBreadcrumb2: "Crea/Modifica Impostazione",
  GestioneSistemaDetailAlertSucess: "Modifica effettuata con successo.",
  GestioneSistemaDetailAlertError:
    "Si è verificato un errore durante la modifica...",
  GestioneSistemaDetailTitle: "Gestione Impostazione di sistema",
  GestioneSistemaDetailId: "Id",
  GestioneSistemaDetailKey: "Chiave",
  GestioneSistemaDetailValue: "Valore",
  GestioneSistemaDetailGroup: "Gruppo",

  //CustomNode
  CustomNodeNewNodeText: "nuovo",
  CustomNodeNewArcText: "nuovo arco",
  CustomNodeImgRestartSession: "Riavvia Sessione",
  CustomNodeNewArcImgAdd: "aggiungi",
  CustomNodeNewArcImgDuplicate: "duplica",
  CustomNodeNewArcDelete: "elimina",
  CustomNodeNewArcHide: "nascondi",

  // {selectedLinguaTesto?.CustomNodeNewArcDelete}
  // selectedLinguaTesto?.CustomNodeNewNodeText

  // import { useLingueStore } from "../sistema/storeLingua";

  //  const { selectedLinguaTesto } = useLingueStore(
  //     (state) => state
  //   );
};

export const FR = {
  //AvpHeader
  AvpHeaderAvpManager: "GESTION AVP",
  AvpHeaderContent: "CONTENUS",
  AvpHeaderUsers: "GESTION UTILISATEURS",
  AvpHeaderSystem: "SYSTÈME",

  //AvpSaveFooter
  AvpSaveFooterTitle: "En cliquant sur Enregistrer",
  AvpSaveFooterSubtitle: "vous confirmez les modifications apportées",
  AvpSaveFooterSave: "ENREGISTRER",
  AvpSaveFooterReset: "ANNULER",
  // DashboardScreen

  DashboardTitle: "Tableau de bord",

  //PasswordRecoverScreen

  PasswordRecoverTitle: "Assistant Virtuel Personnalisable",
  PasswordRecoverSubtitle: "Système de gestion de contenu",
  PasswordRecoverFormTitle: "Réinitialiser le mot de passe",
  PasswordRecoverFormPassword: "Mot de passe",
  PasswordRecoverFormRepeatPassword: "Répéter le mot de passe",
  PasswordRecoverFormButtonConfirm: "CONFIRMER",
  PasswordRecoverDialog: "Votre mot de passe a été mis à jour.",
  PasswordRecoverDialogConfirm: "OK",

  // LoginScreen

  LoginHeaderTitle: "Assistant Virtuel Personnalisable",
  LoginHeaderSubtitle: "Système de gestion de contenu",
  LoginFormTitle: "Accéder à l’espace réservé",
  LoginFormLableUsername: "Nom d’utilisateur",
  LoginFormLablePassword: "Mot de passe",
  LoginFormLablePasswordDimenticata: "Mot de passe oublié ?",
  LoginFormButtonLogin: "CONNEXION",
  LoginDialog:
    "Un e-mail vous a été envoyé avec les instructions pour récupérer le mot de passe",
  LoginDialogConfirm: "OK",

  //GestioneAvpScreen

  AvpListGraphDescription: "Description",
  AvpListGraphCodAsset: "Code de l’actif",
  AvpListGraphTimeout: "Délai",
  AvpListGraphNInstance: "Nb. d’instances",
  AvpListIconGraphic: "graphique",
  AvpListIconCloneAVP: "cloner AVP",
  AvpListIconModify: "modifier",
  AvpListIconDelete: "supprimer",
  AvpListIconInstance: "instance",
  AvpListAlertSuccess: "Modification effectuée avec succès.",
  AvpListAlertError: "Une erreur s’est produite lors de la modification…",
  AvpListTitle: "Créer ou modifier un Assistant Virtuel Personnalisé",
  AvpListTitleAvp: "AVP",
  AvpListButtonAdd: "CRÉER UN NOUVEL AVP",

  AvpListDialogClone: "Cloner l’AVP sélectionné ?",
  AvpListDialogConfirmClone: "OUI",
  AvpListDialogResetClone: "NON",

  AvpListDialogDelete: "Supprimer l’AVP sélectionné ?",
  AvpListDialogConfirmDelete: "OUI",
  AvpListDialogResetDelete: "NON",

  //GestioneAvpDetailScreen

  AvpDetailbreadCrumb1: "Gestion AVP",
  AvpDetailbreadCrumb2: "Créer/Modifier AVP",
  AvpDetailAlertSuccess: "Modification effectuée avec succès.",
  AvpDetailAlertError: "Une erreur s’est produite lors de la modification…",
  AvpDetailTitle: "Données AVP",
  AvpDetailFormDesc: "Description",
  AvpDetailFormCodeAsset: "Code de l’actif",
  AvpDetailFormTimeout: "Délai",
  AvpDetailFormNumberIstance: "Instances simultanées",
  AvpDetailLanguageTitle: "Langues",
  AvpDetailButtonToGraph: "GRAPHE",

  //NewGraphScreen

  AvpGraphDetailbreadCrumb1: "Gestion AVP",
  AvpGraphDetailbreadCrumb2: "Créer/Modifier AVP",
  AvpGraphDetailbreadCrumb3: "Graphe AVP",
  AvpGraphDetailAlertSuccess: "Modification effectuée avec succès.",
  AvpGraphDetailAlertError:
    "Une erreur s’est produite lors de la modification…",

  //GraphEditComponent

  AvpGraphNodeCloseWindows: "FERMER LA FENÊTRE",
  AvpGraphNodeTabProperty: "Propriétés",
  AvpGraphNodeFormName: "Nom",
  AvpGraphNodeFormStartType: "Type de démarrage",
  AvpGraphNodeFormAvatar: "Avatar",
  AvpGraphNodeFormAvatarPosX: "Pos X(%)",
  AvpGraphNodeFormAvatarPosY: "Pos Y(%)",
  AvpGraphNodeFormAvatarDimW: "Dim L(%)",
  AvpGraphNodeFormAvatarDimH: "Dim H(%)",
  AvpGraphNodeFormAvatarZIndex: "Z-Index",
  AvpGraphNodeFormContenuti: "Contenus",
  AvpGraphNodeFormContenutiPosX: "Pos X(%)",
  AvpGraphNodeFormContenutiPosY: "Pos Y(%)",
  AvpGraphNodeFormContenutiDimW: "Dim L(%)",
  AvpGraphNodeFormContenutiDimH: "Dim H(%)",
  AvpGraphNodeFormContenutiZindex: "Z-index",
  AvpGraphNodeFormExsternalApi: "API externe",
  AvpGraphNodeFormFlagGoBack: "Drapeau « Retour »",
  AvpGraphNodeFormAgent: "Agent",
  AvpGraphNodeFormDeleteButton: "supprimer",
  AvpGraphNodeFormButtonSelect: "SÉLECTIONNER",
  AvpGraphNodeFormLoadingFileAvatar: "Chargement du fichier Avatar",
  AvpGraphNodeFormAvatarType: "Type d’avatar",
  AvpGraphNodeFormAvatarTypeFirstOption: "Sélectionner…",
  AvpGraphNodeFormSaveButton: "ENREGISTRER",
  AvpGraphNodeFormResetButton: "ANNULER",

  //AvpNodeContentArcsSection

  AvpNodeContentArcsColumnsText: "Texte",
  AvpNodeContentArcsColumnsEndNode: "Noeud de fin",
  AvpNodeContentArcsButtonEdit: "modifier",
  AvpNodeContentArcsButtonDelete: "supprimer",
  AvpNodeContentArcsButtonMoveUp: "déplacer vers le haut",
  AvpNodeContentArcsButtonMoveDown: "déplacer vers le bas",
  AvpNodeContentArcsArcTitle: "Arcs",
  AvpNodeContentArcsButtonNew: "NOUVEL ARC",
  AvpNodeContentArcsAlertDelete:
    "Impossible de supprimer l’arc depuis le noeud START",
  AvpNodeContentArcsDialogDelete: "Supprimer l’arc sélectionné ?",
  AvpNodeContentArcsDialogConfirm: "OUI",

  //AvpNodeContentPlaylistSection
  AvpNodeContentPlaylistColumnsTypr: "Type",
  AvpNodeContentPlaylistColumnsName: "Nom",
  AvpNodeContentPlaylistColumnsDuration: "Durée",
  AvpNodeContentPlaylistButtonEdit: "modifier",
  AvpNodeContentPlaylistButtonDelete: "supprimer",
  AvpNodeContentPlaylistButtonMoveUp: "déplacer vers le haut",
  AvpNodeContentPlaylistButtonMoveDown: "déplacer vers le bas",
  AvpNodeContentPlaylistTitle: "Playlist",
  AvpNodeContentPlaylistButtonNewFile: "NOUVEAU FICHIER",
  AvpNodeContentPlaylistDialog: "Supprimer le fichier sélectionné ?",
  AvpNodeContentPlaylistDialogDecline: "NON",
  AvpNodeContentPlaylistDialogConfirm: "OUI",

  //NewGestioneArcoScreen

  NewGestioneArcoBreadcrumb1: "Gestion AVP",
  NewGestioneArcoBreadcrumb2: "Créer/Modifier AVP",
  NewGestioneArcoBreadcrumb3: "Graphe AVP",
  NewGestioneArcoBreadcrumb4: "Arc",
  NewGestioneArcoAlertSuccess: "Modification effectuée avec succès.",
  NewGestioneArcoAlertError:
    "Une erreur s’est produite lors de la modification…",
  NewGestioneArcoTitle: "Gestion de l’Arc",
  NewGestioneArcoFormStartNode: "Noeud de départ",
  NewGestioneArcoFormEndNode: "Noeud d’arrivée",
  NewGestioneArcoTextArc: "Texte (choix affiché sur l’interface interactive)",
  NewGestioneArcoFormCheckboxNotActive: "Non actif",
  NewGestioneArcoCheckboxResetSession: "Réinitialisation de la session",
  ANewGestioneArcoCheckboxSkipToNextNode: "Exécuter le noeud suivant",

  //GestioneAvpContentPlaylistFileScreen
  GestioneAvpContentPlaylistFileBreadcrumb1: "Gestion AVP",
  GestioneAvpContentPlaylistFileBreadcrumb2: "Créer/Modifier AVP",
  GestioneAvpContentPlaylistFileBreadcrumb3: "Créer/Modifier AVP",
  GestioneAvpContentPlaylistFileBreadcrumb4: "Fichier de playlist",
  GestioneAvpContentPlaylistFileAlertSucess:
    "Modification effectuée avec succès.",
  GestioneAvpContentPlaylistFileAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneAvpContentPlaylistFileFormTitle: "Gestion du fichier de playlist",
  GestioneAvpContentPlaylistFileFormIdPlaylist: "ID Playlist",
  GestioneAvpContentPlaylistFileFormFile: "Fichier",
  GestioneAvpContentPlaylistFileFormDescription: "Description",
  GestioneAvpContentPlaylistFileFormUrl: "URL",
  GestioneAvpContentPlaylistFileFormDuration: "Durée d’affichage",
  GestioneAvpContentPlaylistFileFormSettings: "Paramètres",
  GestioneAvpContentPlaylistFileCheckboxLoop: "Boucle",
  GestioneAvpContentPlaylistFileCheckboxRestartPlaylist:
    "Redémarrer la playlist",

  // GestioneAvpScreen

  GestioneAvpIstanceBreadcrumb1: "Gestion AVP",
  GestioneAvpIstanceBreadcrumb2: "AVP",
  GestioneAvpIstanceBreadcrumb3: "Instances",
  GestioneAvpInstancceDialogTitle: "Confirmer le clonage",
  GestioneAvpIstanceColumnUser: "Utilisateur",
  GestioneAvpIstanceColumnDurSession: "Dur. session",
  GestioneAvpIstanceColumnQRcode: "QR Code",
  GestioneAvpIstanceColumnPIN: "PIN",
  GestioneAvpIstanceColumnTypeInstance: "Type d’instance",
  GestioneAvpIstanceImgEdit: "modifier",
  GestioneAvpIstanceImgDelete: "supprimer",
  GestioneAvpIstanceImgQrCode: "QR Code",
  GestioneAvpIstanceImgPreview: "aperçu",
  GestioneAvpIstanceImgPreviewInteraction: "aperçu avec interactions",
  GestioneAvpIstanceAlertSuccess: "Modification effectuée avec succès.",
  GestioneAvpIstanceAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneAvpIstanceTitle:
    "Gérer les instances de l’Assistant Virtuel Personnalisé",
  GestioneAvpIstanceFormIstance: "instances",
  GestioneAvpIstanceFormCreateIstance: "CRÉER INSTANCE",

  GestioneAvpIstanceAlertTitle: "Supprimer l’instance sélectionnée ?",
  GestioneAvpIstanceAlertDelete: "Supprimer l’instance sélectionnée ?",
  GestioneAvpIstanceAlertConfirm: "OUI",
  GestioneAvpIstanceAlertUndo: "NON",

  // GestioneAvpIstanzeDetailScreen

  GestioneAvpIstanzeDetailBreadcrumb1: "Gestion AVP",
  GestioneAvpIstanzeDetailBreadcrumb2: "AVP",
  GestioneAvpIstanzeDetailBreadcrumb3: "Instances",
  GestioneAvpIstanzeDetailBreadcrumb4: "Modifier l’Instance",
  GestioneAvpIstanzeDetailAlertSuccess: "Modification effectuée avec succès.",
  GestioneAvpIstanzeDetailAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneAvpIstanzeDetailTitle: "Données de l’instance AVP",
  GestioneAvpIstanzeDetailUser: "Utilisateur",
  GestioneAvpIstanzeDetailIstanceType: "Type d’instance",
  GestioneAvpIstanzeDetailIstanceOrientation: "Orientation de l’instance",
  GestioneAvpIstanzeDetailOptionOrizzontal: "Horizontale",
  GestioneAvpIstanzeDetailOptionVeritcal: "Verticale",
  GestioneAvpIstanzeDetailDurationSession: "Durée de session",
  GestioneAvpIstanzeDetailPIN: "PIN",
  GestioneAvpIstanzeDetailBlur: "Flou",
  GestioneAvpIstanzeDetailQRcode: "QR Code",
  GestioneAvpIstanzeDetailText: "Texte",
  GestioneAvpIstanzeDetailPreset: "Préréglage",
  GestioneAvpIstanzeDetailStyles: "Styles",
  GestioneAvpIstanzeDetailAlign: "Alignement",
  GestioneAvpIstanzeDetailDimension: "Dimensions",

  // GestioneUtentiScreen

  GestioneUtentiBreadcrumb1: "Gestion des Utilisateurs",
  GestioneUtentiColumnName: "Prénom",
  GestioneUtentiColumnSurname: "Nom",
  GestioneUtentiColumnEmail: "E-mail",
  GestioneUtentiColumnTel: "Téléphone",
  GestioneUtentiColumnUsername: "Nom d’utilisateur",
  GestioneUtentiImgEdit: "modifier",
  GestioneUtentiImgDelete: "supprimer",
  GestioneUtentiImgRestore: "restaurer",
  GestioneUtentiAlertSuccess: "Modification effectuée avec succès.",
  GestioneUtentiAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneUtentiTabUser: "Utilisateurs",
  GestioneUtentiTabGroup: "Groupes",
  GestioneUtentiMainTitle: "Créer ou modifier un utilisateur",
  GestioneUtentiUserTitle: "Utilisateurs",
  GestioneUtentiButtonNew: "CRÉER UN NOUVEL UTILISATEUR",
  GestioneUtentiState: "État",
  GestioneUtentiOptionActive: "Actifs",
  GestioneUtentiOptionNotActive: "Inactifs",
  GestioneUtentiDialogDisableUser:
    "Voulez-vous désactiver l’utilisateur sélectionné ?",
  GestioneUtentiDialogConfirm: "OUI",
  GestioneUtentiDialogUndo: "NON",

  // GestioneUtenteDetailScreen
  GestioneUtenteDetailBreadcrumb1: "Gestion des Utilisateurs",
  GestioneUtenteDetailBreadcrumb2: "Créer/Modifier Utilisateur",
  GestioneUtenteDetailAlertSucces: "Modification effectuée avec succès.",
  GestioneUtenteDetailAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneUtenteDetailTitle: "Gestion de l’Utilisateur",
  GestioneUtenteDetailName: "Prénom",
  GestioneUtenteDetailSurname: "Nom",
  GestioneUtenteDetailEmail: "E-mail",
  GestioneUtenteDetailTel: "Téléphone",
  GestioneUtenteDetailUsername: "Nom d’utilisateur",
  GestioneUtenteDetailPassword: "Mot de passe",
  GestioneUtenteDetailGroupTitle: "Groupe",

  // GestioneGruppiUtenteScreen
  GestioneGruppiUtenteBreadcrumb1: "Gestion des Utilisateurs",
  GestioneGruppiUtenteBreadcrumb2: "Gestion des Groupes",
  GestioneGruppiUtenteColumnDesc: "Description",
  GestioneGruppiUtenteColumnBillingTo: "Facturation",
  GestioneGruppiUtenteColumnRifAmm: "Réf. Adm.",
  GestioneGruppiUtenteColumnRifAmmMail: "E-mail Réf. Adm.",
  GestioneGruppiUtenteColumnRifAmmTel: "Tél. Réf. Adm.",
  GestioneGruppiUtenteImgEdit: "modifier",
  GestioneGruppiUtenteImgDelete: "supprimer",
  GestioneGruppiUtenteImgRestore: "restaurer",
  GestioneGruppiUtenteAlertSuccess: "Modification effectuée avec succès.",
  GestioneGruppiUtenteAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneGruppiUtenteUserTab: "Utilisateurs",
  GestioneGruppiUtenteGroupTab: "Groupes",
  GestioneGruppiUtenteTitle: "Créer ou modifier un groupe",
  GestioneGruppiUtenteSubTitle: "Groupes d’utilisateurs",
  GestioneGruppiUtenteButtonNew: "CRÉER UN NOUVEAU GROUPE D’UTILISATEURS",
  GestioneGruppiUtenteState: "État",
  GestioneGruppiUtenteOptionActive: "Actifs",
  GestioneGruppiUtenteOptionNotActive: "Inactifs",
  GestioneGruppiUtenteDialogTitle: "Confirmer la désactivation",
  GestioneGruppiUtenteDialogText:
    "Voulez-vous désactiver le groupe sélectionné ?",
  GestioneGruppiUtenteDialogConfirm: "OUI",
  GestioneGruppiUtenteDialogUndo: "NON",

  // GestioneGruppoUtenteDetailScreen

  GestioneGruppoUtenteDetailBreadcrumb1: "Gestion des Utilisateurs",
  GestioneGruppoUtenteDetailBreadcrumb2: "Gestion des Groupes",
  GestioneGruppoUtenteDetailBreadcrumb3: "Créer/Modifier Groupe",
  GestioneGruppoUtenteDetailAlertSuccess: "Modification effectuée avec succès.",
  GestioneGruppoUtenteDetailAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneGruppoUtenteDetailTitle: "Gestion du Groupe d’Utilisateurs",
  GestioneGruppoUtenteDetailDescription: "Description",
  GestioneGruppoUtenteDetailIDBulling: "ID de facturation",
  GestioneGruppoUtenteDetailRifAmministrative: "Référence administrative",
  GestioneGruppoUtenteDetailRifAmmEmail: "E-mail Réf. Adm.",
  GestioneGruppoUtenteDetailRifAmmTel: "Téléphone Réf. Adm.",

  // GestioneContenutiScreen

  GestioneContenutiColumnDesc: "Description",
  GestioneContenutiColumnType: "Type",
  GestioneContenutiColumnFile: "Fichier",
  GestioneContenutiColumnFolder: "Dossier",
  GestioneContenutiPageTitle: "Gérer les contenus",
  GestioneContenutiPageSubtitle: "Contenus",
  GestioneContenutiImgPreview: "aperçu",
  GestioneContenutiImgEdit: "modifier",
  GestioneContenutiImgDelete: "supprimer",
  GestioneContenutiAlertSuccess: "Modification effectuée avec succès.",
  GestioneContenutiAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneContenutiButtonGoToAgent: "CONTENUS AGENT",
  GestioneContenutiCreateAvatar: "CRÉER AVATAR",
  GestioneContenutiNewContent: "CRÉER NOUVEAU",
  GestioneContenutiTitle: "Type de contenu",
  GestioneContenutiOptionAll: "Tous",
  GestioneContenutiSearchLabel: "Texte de recherche",
  GestioneContenutiButtonSearch: "RECHERCHER",
  GestioneContenutiDialogTitle: "Confirmer la suppression",
  GestioneContenutiDialogDeleteText: "Supprimer le contenu sélectionné ?",
  GestioneContenutiDialogDeleteFolder:
    "Supprimer le dossier sélectionné et tout son contenu ?",
  GestioneContenutiDialogDeleteTrash:
    "Vider la corbeille et supprimer tout le contenu ?",
  GestioneContenutiDialogConfirm: "OUI",
  GestioneContenutiDialogUndo: "NON",

  // GestioneContenutiPickScreen

  GestioneContenutiPickBreadcrumb1: "Gestion AVP",
  GestioneContenutiPickBreadcrumb2: "Créer/Modifier AVP",
  GestioneContenutiPickBreadcrumb3: "Graphe AVP",
  GestioneContenutiPickBreadcrumb4: "Sélection de contenus",
  GestioneContenutiPickPageTitle: "Gérer les contenus",
  GestioneContenutiPickTitleAddToPlaylist:
    "Associer un contenu multimédia à la playlist du noeud",
  GestioneContenutiPickTitleAddToArc: "Associer une image à l’arc sélectionné",
  GestioneContenutiPickTitleAddToNode:
    "Associer un avatar au noeud sélectionné",
  GestioneContenutiPickTitleAddToLoadingNode:
    "Associer une image de chargement au noeud sélectionné",
  GestioneContenutiPickCreateAgent: "Sélectionner une nouvelle image",
  GestioneContenutiPickColumnName: "Nom",
  GestioneContenutiPickColumnType: "Type",
  GestioneContenutiPickColumnFile: "Fichier",
  GestioneContenutiPickColumnFolder: "Dossier",
  GestioneContenutiPickImgDelete: "supprimer",
  GestioneContenutiPickImgEdit: "modifier",
  GestioneContenutiPickImgAdd: "ajouter",
  GestioneContenutiPickImgPreview: "aperçu",
  GestioneContenutiPickAlertSuccess: "Modification effectuée avec succès.",
  GestioneContenutiPickAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneContenutiPickSubtitle: "Contenus",
  GestioneContenutiPickButtonNew: "CRÉER NOUVEAU",
  GestioneContenutiPickContentType: "Type de contenu",
  GestioneContenutiPickOptionAll: "Tous",
  GestioneContenutiPickSearchText: "Texte de recherche",
  GestioneContenutiPickDialogTitle: "Confirmer la suppression",
  GestioneContenutiPickDialogText: "Supprimer le contenu sélectionné ?",
  GestioneContenutiPickDialogConfirm: "OUI",
  GestioneContenutiPickDialogUndo: "NON",

  // GestioneContenutiFileScreen

  GestioneContenutiFileBreadcrumb1: "Gestion des Contenus",
  GestioneContenutiFileBreadcrumb2: "Créer/Modifier Fichier",
  GestioneContenutiFileDialogSuccess: "Modification effectuée avec succès.",
  GestioneContenutiFileDialogError:
    "Une erreur s’est produite lors de la modification…",
  GestioneContenutiFileTitle: "Gestion du Fichier",
  GestioneContenutiFileName: "Nom",
  GestioneContenutiFileNameFile: "Nom du fichier",
  GestioneContenutiFileContentType: "Type de contenu",
  GestioneContenutiFileOptionChoose: "Sélectionner…",
  GestioneContenutiFileUploadFile: "Téléverser le fichier",
  GestioneContenutiFileFatherFolder: "Dossier parent",

  // GestioneContenutiTree

  GestioneContenutiTreeImgAdd: "ajouter",
  GestioneContenutiTreeImgEdit: "modifier",
  GestioneContenutiTreeImgDelete: "supprimer",
  GestioneContenutiTreeImgUndo: "annuler",
  GestioneContenutiTreeImgDel: "effacer",

  // GestioneContenutiAvatarScreen
  GestioneContenutiAvatarBreadcrumb1: "Gestion des Contenus",
  GestioneContenutiAvatarBreadcrumb2: "Créer Avatar",
  GestioneContenutiAvatarAlertSucces: "Modification effectuée avec succès.",
  GestioneContenutiAvatarAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneContenutiAvatarTitle: "Gestion de l’Avatar",
  ccccc: "Sélectionner le fichier à animer",
  GestioneContenutiAvatarButtonFile: "SÉLECTIONNER",
  GestioneContenutiAvatarName: "Nom",
  GestioneContenutiAvatarGender: "Genre",
  GestioneContenutiAvatarOptionSelection: "Sélectionner…",
  GestioneContenutiAvatarLang: "Langue",
  GestioneContenutiAvatarVoice: "Voix",
  GestioneContenutiAvatarText: "Texte",
  GestioneContenutiAvatarSubtitle: "Sous-titres",
  GestioneContenutiAvatarFooterTitle: "En cliquant sur Enregistrer",
  GestioneContenutiAvatarFooterSubtitle:
    "vous confirmez les modifications apportées",
  GestioneContenutiAvatarFooterSaveContinue: "ENREGISTRER ET FERMER",
  GestioneContenutiAvatarFooterSaveClose: "ENREGISTRER ET CONTINUER",
  GestioneContenutiAvatarFooterUndo: "ANNULER",

  // GestioneAgentAIScreen
  GestioneAgentAIAlertErrorAddFile: "fichier non valide",
  GestioneAgentAIBreadcrumb1: "Gestion des Contenus",
  GestioneAgentAIBreadcrumb2: "Créer Agent",
  GestioneAgentAIAlertSuccess: "Modification effectuée avec succès.",
  GestioneAgentAIAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneAgentAITitleCreate: "Création d’agent",
  GestioneAgentAITitleEdit: "Modifier l’Agent",
  GestioneAgentAIName: "Nom",
  GestioneAgentAIGreetingsMessage: "Message de bienvenue",
  GestioneAgentAILLMmodel: "Modèle LLM",
  GestioneAgentAIButtonOpenChangeLanguge: "Changer de langue",
  GestioneAgentAIAgentVoice: "Voix de l’Agent",
  GestioneAgentAIGender: "Genre",
  GestioneAgentAIOptionSelect: "Sélectionner…",
  GestioneAgentAILang: "Langue",
  GestioneAgentAIVoice: "Voix",

  GestioneAgentAIKnowladgeBase: "Base de connaissances",
  GestioneAgentAIKnowladgeBaseString: "Informations textuelles à fournir",
  GestioneAgentAIAlertLimitDocument: "5 fichiers maximum",
  GestioneAgentAIImgDelete: "supprimer",
  GestioneAgentAIAgentImage: "Image de l’Agent",
  GestioneAgentAIImageFile: "Fichier image :",
  GestioneAgentAIButtonSelect: "SÉLECTIONNER",
  GestioneAgentFlagSizeImage: "Photo taille complète",

  GestioneAgentAIButtonSave: "ENREGISTRER",
  GestioneAgentAIButtonUndo: "ANNULER",

  // GestioneAgentListScreen
  GestioneAgentListBreadcrumb1: "Gestion des Agents",
  GestioneAgentListPageTitle: "Gérer les contenus des Agents",
  GestioneAgentListColumnDesc: "Description",
  GestioneAgentListColumnStatus: "Statut",
  GestioneAgentListStatusDone: "Actif",
  GestioneAgentListStatusError: "Erreur",
  GestioneAgentListStatusLoading: "En cours",
  GestioneAgentListImgEdit: "modifier",
  GestioneAgentListImgDelete: "supprimer",
  GestioneAgentListImgAdd: "ajouter",
  GestioneAgentListAlertSuccess: "Modification effectuée avec succès.",
  GestioneAgentListAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneAgentListButtonNew: "CRÉER AGENT",
  GestioneAgentListDialogTitle: "Supprimer le contenu sélectionné ?",
  GestioneAgentListDialogConfirm: "OUI",
  GestioneAgentListDialogUndo: "NON",

  // GestioneContenutiFolder

  GestioneContenutiFolderBreadcrumb1: "Gestion des Contenus",
  GestioneContenutiFolderBreadcrumb2: "Créer/Modifier Dossier",
  GestioneContenutiFolderAlertSuccess: "Modification effectuée avec succès.",
  GestioneContenutiFolderAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneContenutiFolderMnageFolder: "Gestion du Dossier",
  GestioneContenutiFolderDesc: "Description",
  GestioneContenutiFolderFatherFolder: "Dossier parent",

  // GestioneSistemaScreen
  GestioneSistemaBreadcrumb1: "Gestion du Système",
  GestioneSistemaColumnID: "ID",
  GestioneSistemaColumnKey: "Clé",
  GestioneSistemaColumnValue: "Valeur",
  GestioneSistemaColumnSettingGroup: "Groupe",
  GestioneSistemaImgEdit: "modifier",
  GestioneSistemaImgDelete: "supprimer",
  GestioneSistemaImgRestore: "restaurer",
  GestioneSistemaAlertSucess: "Modification effectuée avec succès.",
  GestioneSistemaAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneSistemaTabSetting: "Paramètres",
  GestioneSistemaTabLang: "Langues",
  GestioneSistemaTitle: "Créer ou modifier les paramètres système",
  GestioneSistemaSubtitle: "Paramètres",
  GestioneSistemaButtonNew: "CRÉER UN NOUVEL ÉLÉMENT",
  GestioneSistemaDialogTitle: "Voulez-vous supprimer l’élément sélectionné ?",
  GestioneSistemaDialogConfirm: "OUI",
  GestioneSistemaDialogUndo: "NON",

  // GestioneLingueScreen

  GestioneLingueBreadcrumb1: "Système",
  GestioneLingueBreadcrumb2: "Langues",
  GestioneLingueColumnCodLang: "Code langue",
  GestioneLingueColumnDesc: "Description",
  GestioneLingueImgEdit: "modifier",
  GestioneLingueDialogSuccess: "Modification effectuée avec succès.",
  GestioneLingueDialogError:
    "Une erreur s’est produite lors de la modification…",
  GestioneLingueTabSystem: "Système",
  GestioneLingueTabLang: "Langues",
  GestioneLingueTitle: "Créer ou modifier une langue",
  GestioneLingueSubtitle: "Langues",
  GestioneLingueButtonNew: "CRÉER NOUVELLE LANGUE",

  // GestioneLingueDetailScreen
  GestioneLingueDetailBreadcrumb1: "Système",
  GestioneLingueDetailBreadcrumb2: "Gestion des Langues",
  GestioneLingueDetailAlertSucess: "Modification effectuée avec succès.",
  GestioneLingueDetailAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneLingueDetailTitle: "Gestion de la Langue",
  GestioneLingueDetailCodLang: "Code langue",
  GestioneLingueDetailDesc: "Description",

  // GestioneSistemaDetailScreen
  GestioneSistemaDetailBreadcrumb1: "Gestion du Système",
  GestioneSistemaDetailBreadcrumb2: "Créer/Modifier Paramètre",
  GestioneSistemaDetailAlertSucess: "Modification effectuée avec succès.",
  GestioneSistemaDetailAlertError:
    "Une erreur s’est produite lors de la modification…",
  GestioneSistemaDetailTitle: "Gestion du Paramètre système",
  GestioneSistemaDetailId: "ID",
  GestioneSistemaDetailKey: "Clé",
  GestioneSistemaDetailValue: "Valeur",
  GestioneSistemaDetailGroup: "Groupe",

  //CustomNode
  CustomNodeNewNodeText: "nouveau",
  CustomNodeNewArcText: "nouvel arc",
  CustomNodeImgRestartSession: "Redémarrer la session",
  CustomNodeNewArcImgAdd: "ajouter",
  CustomNodeNewArcImgDuplicate: "dupliquer",
  CustomNodeNewArcDelete: "supprimer",
  CustomNodeNewArcHide: "masquer",

  // {selectedLinguaTesto?.CustomNodeNewArcDelete}
  // selectedLinguaTesto?.CustomNodeNewNodeText

  // import { useLingueStore } from "../sistema/storeLingua";

  //  const { selectedLinguaTesto } = useLingueStore(
  //     (state) => state
  //   );
};

export const ENG = {
  //AvpHeader
  AvpHeaderAvpManager: "AVP MANAGEMENT",
  AvpHeaderContent: "CONTENT",
  AvpHeaderUsers: "USER MANAGEMENT",
  AvpHeaderSystem: "SYSTEM",

  //AvpSaveFooter
  AvpSaveFooterTitle: "By clicking Save",
  AvpSaveFooterSubtitle: "you confirm the changes made",
  AvpSaveFooterSave: "SAVE",
  AvpSaveFooterReset: "CANCEL",
  // DashboardScreen

  DashboardTitle: "Dashboard",

  //PasswordRecoverScreen

  PasswordRecoverTitle: "Customizable Virtual Assistant",
  PasswordRecoverSubtitle: "Content Management System",
  PasswordRecoverFormTitle: "Reset password",
  PasswordRecoverFormPassword: "Password",
  PasswordRecoverFormRepeatPassword: "Repeat password",
  PasswordRecoverFormButtonConfirm: "CONFIRM",
  PasswordRecoverDialog: "Your password has been updated.",
  PasswordRecoverDialogConfirm: "OK",

  // LoginScreen

  LoginHeaderTitle: "Customizable Virtual Assistant",
  LoginHeaderSubtitle: "Content Management System",
  LoginFormTitle: "Access the reserved area",
  LoginFormLableUsername: "Username",
  LoginFormLablePassword: "Password",
  LoginFormLablePasswordDimenticata: "Forgot your password?",
  LoginFormButtonLogin: "LOGIN",
  LoginDialog:
    "An email has been sent with instructions to recover your password",
  LoginDialogConfirm: "OK",

  //GestioneAvpScreen

  AvpListGraphDescription: "Description",
  AvpListGraphCodAsset: "Asset code",
  AvpListGraphTimeout: "Timeout",
  AvpListGraphNInstance: "No. of instances",
  AvpListIconGraphic: "chart",
  AvpListIconCloneAVP: "clone AVP",
  AvpListIconModify: "edit",
  AvpListIconDelete: "delete",
  AvpListIconInstance: "instance",
  AvpListAlertSuccess: "Changes saved successfully.",
  AvpListAlertError: "An error occurred while making the changes...",
  AvpListTitle: "Create or edit a Custom Virtual Assistant",
  AvpListTitleAvp: "AVP",
  AvpListButtonAdd: "CREATE NEW AVP",

  AvpListDialogClone: "Clone the selected AVP?",
  AvpListDialogConfirmClone: "YES",
  AvpListDialogResetClone: "NO",

  AvpListDialogDelete: "Delete the selected AVP?",
  AvpListDialogConfirmDelete: "YES",
  AvpListDialogResetDelete: "NO",

  //GestioneAvpDetailScreen

  AvpDetailbreadCrumb1: "AVP Management",
  AvpDetailbreadCrumb2: "Create/Edit AVP",
  AvpDetailAlertSuccess: "Changes saved successfully.",
  AvpDetailAlertError: "An error occurred while making the changes...",
  AvpDetailTitle: "AVP Data",
  AvpDetailFormDesc: "Description",
  AvpDetailFormCodeAsset: "Asset code",
  AvpDetailFormTimeout: "Timeout",
  AvpDetailFormNumberIstance: "Concurrent instances",
  AvpDetailLanguageTitle: "Languages",
  AvpDetailButtonToGraph: "GRAPH",

  //NewGraphScreen

  AvpGraphDetailbreadCrumb1: "AVP Management",
  AvpGraphDetailbreadCrumb2: "Create/Edit AVP",
  AvpGraphDetailbreadCrumb3: "AVP Graph",
  AvpGraphDetailAlertSuccess: "Changes saved successfully.",
  AvpGraphDetailAlertError: "An error occurred while making the changes...",

  //GraphEditComponent

  AvpGraphNodeCloseWindows: "CLOSE WINDOW",
  AvpGraphNodeTabProperty: "Properties",
  AvpGraphNodeFormName: "Name",
  AvpGraphNodeFormStartType: "Start type",
  AvpGraphNodeFormAvatar: "Avatar",
  AvpGraphNodeFormAvatarPosX: "Pos X(%)",
  AvpGraphNodeFormAvatarPosY: "Pos Y(%)",
  AvpGraphNodeFormAvatarDimW: "Dim W(%)",
  AvpGraphNodeFormAvatarDimH: "Dim H(%)",
  AvpGraphNodeFormAvatarZIndex: "Z-Index",
  AvpGraphNodeFormContenuti: "Content",
  AvpGraphNodeFormContenutiPosX: "Pos X(%)",
  AvpGraphNodeFormContenutiPosY: "Pos Y(%)",
  AvpGraphNodeFormContenutiDimW: "Dim W(%)",
  AvpGraphNodeFormContenutiDimH: "Dim H(%)",
  AvpGraphNodeFormContenutiZindex: "Z-index",
  AvpGraphNodeFormExsternalApi: "External API",
  AvpGraphNodeFormFlagGoBack: "Go Back Flag",
  AvpGraphNodeFormAgent: "Agent",
  AvpGraphNodeFormDeleteButton: "delete",
  AvpGraphNodeFormButtonSelect: "SELECT",
  AvpGraphNodeFormLoadingFileAvatar: "Loading Avatar file",
  AvpGraphNodeFormAvatarType: "Avatar type",
  AvpGraphNodeFormAvatarTypeFirstOption: "Select...",
  AvpGraphNodeFormSaveButton: "SAVE",
  AvpGraphNodeFormResetButton: "CANCEL",

  //AvpNodeContentArcsSection

  AvpNodeContentArcsColumnsText: "Text",
  AvpNodeContentArcsColumnsEndNode: "End node",
  AvpNodeContentArcsButtonEdit: "edit",
  AvpNodeContentArcsButtonDelete: "delete",
  AvpNodeContentArcsButtonMoveUp: "move up",
  AvpNodeContentArcsButtonMoveDown: "move down",
  AvpNodeContentArcsArcTitle: "Arcs",
  AvpNodeContentArcsButtonNew: "NEW ARC",
  AvpNodeContentArcsAlertDelete: "Cannot delete the arc from the START node",
  AvpNodeContentArcsDialogDelete: "Delete the selected arc?",
  AvpNodeContentArcsDialogConfirm: "YES",

  //AvpNodeContentPlaylistSection
  AvpNodeContentPlaylistColumnsTypr: "Type",
  AvpNodeContentPlaylistColumnsName: "Name",
  AvpNodeContentPlaylistColumnsDuration: "Duration",
  AvpNodeContentPlaylistButtonEdit: "edit",
  AvpNodeContentPlaylistButtonDelete: "delete",
  AvpNodeContentPlaylistButtonMoveUp: "move up",
  AvpNodeContentPlaylistButtonMoveDown: "move down",
  AvpNodeContentPlaylistTitle: "Playlist",
  AvpNodeContentPlaylistButtonNewFile: "NEW FILE",
  AvpNodeContentPlaylistDialog: "Delete the selected file?",
  AvpNodeContentPlaylistDialogDecline: "NO",
  AvpNodeContentPlaylistDialogConfirm: "YES",

  //NewGestioneArcoScreen

  NewGestioneArcoBreadcrumb1: "AVP Management",
  NewGestioneArcoBreadcrumb2: "Create/Edit AVP",
  NewGestioneArcoBreadcrumb3: "AVP Graph",
  NewGestioneArcoBreadcrumb4: "Arc",
  NewGestioneArcoAlertSuccess: "Changes saved successfully.",
  NewGestioneArcoAlertError: "An error occurred while making the changes...",
  NewGestioneArcoTitle: "Arc Management",
  NewGestioneArcoFormStartNode: "Start node",
  NewGestioneArcoFormEndNode: "End node",
  NewGestioneArcoTextArc:
    "Text (choice displayed on the interactive interface)",
  NewGestioneArcoFormCheckboxNotActive: "Not active",
  NewGestioneArcoCheckboxResetSession: "Session reset",
  ANewGestioneArcoCheckboxSkipToNextNode: "Execute next node",

  //GestioneAvpContentPlaylistFileScreen
  GestioneAvpContentPlaylistFileBreadcrumb1: "AVP Management",
  GestioneAvpContentPlaylistFileBreadcrumb2: "Create/Edit AVP",
  GestioneAvpContentPlaylistFileBreadcrumb3: "Create/Edit AVP",
  GestioneAvpContentPlaylistFileBreadcrumb4: "Playlist File",
  GestioneAvpContentPlaylistFileAlertSucess: "Changes saved successfully.",
  GestioneAvpContentPlaylistFileAlertError:
    "An error occurred while making the changes...",
  GestioneAvpContentPlaylistFileFormTitle: "Playlist File Management",
  GestioneAvpContentPlaylistFileFormIdPlaylist: "Playlist ID",
  GestioneAvpContentPlaylistFileFormFile: "File",
  GestioneAvpContentPlaylistFileFormDescription: "Description",
  GestioneAvpContentPlaylistFileFormUrl: "URL",
  GestioneAvpContentPlaylistFileFormDuration: "Display duration",
  GestioneAvpContentPlaylistFileFormSettings: "Settings",
  GestioneAvpContentPlaylistFileCheckboxLoop: "Loop",
  GestioneAvpContentPlaylistFileCheckboxRestartPlaylist: "Restart playlist",

  // GestioneAvpScreen

  GestioneAvpIstanceBreadcrumb1: "AVP Management",
  GestioneAvpIstanceBreadcrumb2: "AVP",
  GestioneAvpIstanceBreadcrumb3: "Instances",
  GestioneAvpInstancceDialogTitle: "Confirm cloning",
  GestioneAvpIstanceColumnUser: "User",
  GestioneAvpIstanceColumnDurSession: "Sess. duration",
  GestioneAvpIstanceColumnQRcode: "QR Code",
  GestioneAvpIstanceColumnPIN: "PIN",
  GestioneAvpIstanceColumnTypeInstance: "Instance type",
  GestioneAvpIstanceImgEdit: "edit",
  GestioneAvpIstanceImgDelete: "delete",
  GestioneAvpIstanceImgQrCode: "QR Code",
  GestioneAvpIstanceImgPreview: "preview",
  GestioneAvpIstanceImgPreviewInteraction: "preview with interactions",
  GestioneAvpIstanceAlertSuccess: "Changes saved successfully.",
  GestioneAvpIstanceAlertError: "An error occurred while making the changes...",
  GestioneAvpIstanceTitle:
    "Manage the instances of the Custom Virtual Assistant",
  GestioneAvpIstanceFormIstance: "instances",
  GestioneAvpIstanceFormCreateIstance: "CREATE INSTANCE",

  GestioneAvpIstanceAlertTitle: "Delete the selected instance?",
  GestioneAvpIstanceAlertDelete: "Delete the selected instance?",
  GestioneAvpIstanceAlertConfirm: "YES",
  GestioneAvpIstanceAlertUndo: "NO",

  // GestioneAvpIstanzeDetailScreen

  GestioneAvpIstanzeDetailBreadcrumb1: "AVP Management",
  GestioneAvpIstanzeDetailBreadcrumb2: "AVP",
  GestioneAvpIstanzeDetailBreadcrumb3: "Instances",
  GestioneAvpIstanzeDetailBreadcrumb4: "Edit Instance",
  GestioneAvpIstanzeDetailAlertSuccess: "Changes saved successfully.",
  GestioneAvpIstanzeDetailAlertError:
    "An error occurred while making the changes...",
  GestioneAvpIstanzeDetailTitle: "AVP Instance Data",
  GestioneAvpIstanzeDetailUser: "User",
  GestioneAvpIstanzeDetailIstanceType: "Instance type",
  GestioneAvpIstanzeDetailIstanceOrientation: "Instance orientation",
  GestioneAvpIstanzeDetailOptionOrizzontal: "Horizontal",
  GestioneAvpIstanzeDetailOptionVeritcal: "Vertical",
  GestioneAvpIstanzeDetailDurationSession: "Session duration",
  GestioneAvpIstanzeDetailPIN: "PIN",
  GestioneAvpIstanzeDetailBlur: "Blur",
  GestioneAvpIstanzeDetailQRcode: "QR Code",
  GestioneAvpIstanzeDetailText: "Text",
  GestioneAvpIstanzeDetailPreset: "Preset",
  GestioneAvpIstanzeDetailStyles: "Styles",
  GestioneAvpIstanzeDetailAlign: "Alignment",
  GestioneAvpIstanzeDetailDimension: "Dimensions",

  // GestioneUtentiScreen

  GestioneUtentiBreadcrumb1: "User Management",
  GestioneUtentiColumnName: "First name",
  GestioneUtentiColumnSurname: "Last name",
  GestioneUtentiColumnEmail: "Email",
  GestioneUtentiColumnTel: "Phone",
  GestioneUtentiColumnUsername: "Username",
  GestioneUtentiImgEdit: "edit",
  GestioneUtentiImgDelete: "delete",
  GestioneUtentiImgRestore: "restore",
  GestioneUtentiAlertSuccess: "Changes saved successfully.",
  GestioneUtentiAlertError: "An error occurred while making the changes...",
  GestioneUtentiTabUser: "Users",
  GestioneUtentiTabGroup: "Groups",
  GestioneUtentiMainTitle: "Create or edit a user",
  GestioneUtentiUserTitle: "Users",
  GestioneUtentiButtonNew: "CREATE NEW USER",
  GestioneUtentiState: "Status",
  GestioneUtentiOptionActive: "Active",
  GestioneUtentiOptionNotActive: "Inactive",
  GestioneUtentiDialogDisableUser: "Do you want to disable the selected user?",
  GestioneUtentiDialogConfirm: "YES",
  GestioneUtentiDialogUndo: "NO",

  // GestioneUtenteDetailScreen
  GestioneUtenteDetailBreadcrumb1: "User Management",
  GestioneUtenteDetailBreadcrumb2: "Create/Edit User",
  GestioneUtenteDetailAlertSucces: "Changes saved successfully.",
  GestioneUtenteDetailAlertError:
    "An error occurred while making the changes...",
  GestioneUtenteDetailTitle: "User Management",
  GestioneUtenteDetailName: "First name",
  GestioneUtenteDetailSurname: "Last name",
  GestioneUtenteDetailEmail: "Email",
  GestioneUtenteDetailTel: "Phone",
  GestioneUtenteDetailUsername: "Username",
  GestioneUtenteDetailPassword: "Password",
  GestioneUtenteDetailGroupTitle: "Group",

  // GestioneGruppiUtenteScreen
  GestioneGruppiUtenteBreadcrumb1: "User Management",
  GestioneGruppiUtenteBreadcrumb2: "Group Management",
  GestioneGruppiUtenteColumnDesc: "Description",
  GestioneGruppiUtenteColumnBillingTo: "Billing",
  GestioneGruppiUtenteColumnRifAmm: "Admin ref.",
  GestioneGruppiUtenteColumnRifAmmMail: "Admin ref. Email",
  GestioneGruppiUtenteColumnRifAmmTel: "Admin ref. Phone",
  GestioneGruppiUtenteImgEdit: "edit",
  GestioneGruppiUtenteImgDelete: "delete",
  GestioneGruppiUtenteImgRestore: "restore",
  GestioneGruppiUtenteAlertSuccess: "Changes saved successfully.",
  GestioneGruppiUtenteAlertError:
    "An error occurred while making the changes...",
  GestioneGruppiUtenteUserTab: "Users",
  GestioneGruppiUtenteGroupTab: "Groups",
  GestioneGruppiUtenteTitle: "Create or edit a group",
  GestioneGruppiUtenteSubTitle: "User groups",
  GestioneGruppiUtenteButtonNew: "CREATE NEW USER GROUP",
  GestioneGruppiUtenteState: "Status",
  GestioneGruppiUtenteOptionActive: "Active",
  GestioneGruppiUtenteOptionNotActive: "Inactive",
  GestioneGruppiUtenteDialogTitle: "Disable confirmation",
  GestioneGruppiUtenteDialogText: "Do you want to disable the selected group?",
  GestioneGruppiUtenteDialogConfirm: "YES",
  GestioneGruppiUtenteDialogUndo: "NO",

  // GestioneGruppoUtenteDetailScreen

  GestioneGruppoUtenteDetailBreadcrumb1: "User Management",
  GestioneGruppoUtenteDetailBreadcrumb2: "Group Management",
  GestioneGruppoUtenteDetailBreadcrumb3: "Create/Edit Group",
  GestioneGruppoUtenteDetailAlertSuccess: "Changes saved successfully.",
  GestioneGruppoUtenteDetailAlertError:
    "An error occurred while making the changes...",
  GestioneGruppoUtenteDetailTitle: "User Group Management",
  GestioneGruppoUtenteDetailDescription: "Description",
  GestioneGruppoUtenteDetailIDBulling: "Billing ID",
  GestioneGruppoUtenteDetailRifAmministrative: "Administrative reference",
  GestioneGruppoUtenteDetailRifAmmEmail: "Admin ref. Email",
  GestioneGruppoUtenteDetailRifAmmTel: "Admin ref. Phone",

  // GestioneContenutiScreen

  GestioneContenutiColumnDesc: "Description",
  GestioneContenutiColumnType: "Type",
  GestioneContenutiColumnFile: "File",
  GestioneContenutiColumnFolder: "Folder",
  GestioneContenutiPageTitle: "Manage content",
  GestioneContenutiPageSubtitle: "Content",
  GestioneContenutiImgPreview: "preview",
  GestioneContenutiImgEdit: "edit",
  GestioneContenutiImgDelete: "delete",
  GestioneContenutiAlertSuccess: "Changes saved successfully.",
  GestioneContenutiAlertError: "An error occurred while making the changes...",
  GestioneContenutiButtonGoToAgent: "AGENT CONTENT",
  GestioneContenutiCreateAvatar: "CREATE AVATAR",
  GestioneContenutiNewContent: "CREATE NEW",
  GestioneContenutiTitle: "Content type",
  GestioneContenutiOptionAll: "All",
  GestioneContenutiSearchLabel: "Search text",
  GestioneContenutiButtonSearch: "SEARCH",
  GestioneContenutiDialogTitle: "Confirm deletion",
  GestioneContenutiDialogDeleteText: "Delete the selected content?",
  GestioneContenutiDialogDeleteFolder:
    "Delete the selected folder and all its contents?",
  GestioneContenutiDialogDeleteTrash:
    "Empty the recycle bin and delete all content?",
  GestioneContenutiDialogConfirm: "YES",
  GestioneContenutiDialogUndo: "NO",

  // GestioneContenutiPickScreen

  GestioneContenutiPickBreadcrumb1: "AVP Management",
  GestioneContenutiPickBreadcrumb2: "Create/Edit AVP",
  GestioneContenutiPickBreadcrumb3: "AVP Graph",
  GestioneContenutiPickBreadcrumb4: "Content selection",
  GestioneContenutiPickPageTitle: "Manage content",
  GestioneContenutiPickTitleAddToPlaylist:
    "Associate a media asset to the node playlist",
  GestioneContenutiPickTitleAddToArc: "Associate an image to the selected arc",
  GestioneContenutiPickTitleAddToNode:
    "Associate an avatar to the selected node",
  GestioneContenutiPickTitleAddToLoadingNode:
    "Associate a loading image to the selected node",
  GestioneContenutiPickCreateAgent: "Select new image",
  GestioneContenutiPickColumnName: "Name",
  GestioneContenutiPickColumnType: "Type",
  GestioneContenutiPickColumnFile: "File",
  GestioneContenutiPickColumnFolder: "Folder",
  GestioneContenutiPickImgDelete: "delete",
  GestioneContenutiPickImgEdit: "edit",
  GestioneContenutiPickImgAdd: "add",
  GestioneContenutiPickImgPreview: "preview",
  GestioneContenutiPickAlertSuccess: "Changes saved successfully.",
  GestioneContenutiPickAlertError:
    "An error occurred while making the changes...",
  GestioneContenutiPickSubtitle: "Content",
  GestioneContenutiPickButtonNew: "CREATE NEW",
  GestioneContenutiPickContentType: "Content type",
  GestioneContenutiPickOptionAll: "All",
  GestioneContenutiPickSearchText: "Search text",
  GestioneContenutiPickDialogTitle: "Confirm deletion",
  GestioneContenutiPickDialogText: "Delete the selected content?",
  GestioneContenutiPickDialogConfirm: "YES",
  GestioneContenutiPickDialogUndo: "NO",

  // GestioneContenutiFileScreen

  GestioneContenutiFileBreadcrumb1: "Content Management",
  GestioneContenutiFileBreadcrumb2: "Create/Edit File",
  GestioneContenutiFileDialogSuccess: "Changes saved successfully.",
  GestioneContenutiFileDialogError:
    "An error occurred while making the changes...",
  GestioneContenutiFileTitle: "File Management",
  GestioneContenutiFileName: "Name",
  GestioneContenutiFileNameFile: "File name",
  GestioneContenutiFileContentType: "Content type",
  GestioneContenutiFileOptionChoose: "Select...",
  GestioneContenutiFileUploadFile: "Upload file",
  GestioneContenutiFileFatherFolder: "Parent folder",

  // GestioneContenutiTree

  GestioneContenutiTreeImgAdd: "add",
  GestioneContenutiTreeImgEdit: "edit",
  GestioneContenutiTreeImgDelete: "delete",
  GestioneContenutiTreeImgUndo: "undo",
  GestioneContenutiTreeImgDel: "clear",

  // GestioneContenutiAvatarScreen
  GestioneContenutiAvatarBreadcrumb1: "Content Management",
  GestioneContenutiAvatarBreadcrumb2: "Create Avatar",
  GestioneContenutiAvatarAlertSucces: "Changes saved successfully.",
  GestioneContenutiAvatarAlertError:
    "An error occurred while making the changes...",
  GestioneContenutiAvatarTitle: "Avatar Management",
  ccccc: "Select file to animate",
  GestioneContenutiAvatarButtonFile: "SELECT",
  GestioneContenutiAvatarName: "Name",
  GestioneContenutiAvatarGender: "Gender",
  GestioneContenutiAvatarOptionSelection: "Select...",
  GestioneContenutiAvatarLang: "Language",
  GestioneContenutiAvatarVoice: "Voice",
  GestioneContenutiAvatarText: "Text",
  GestioneContenutiAvatarSubtitle: "Subtitles",
  GestioneContenutiAvatarFooterTitle: "By clicking Save",
  GestioneContenutiAvatarFooterSubtitle: "you confirm the changes made",
  GestioneContenutiAvatarFooterSaveContinue: "SAVE AND CLOSE",
  GestioneContenutiAvatarFooterSaveClose: "SAVE AND CONTINUE",
  GestioneContenutiAvatarFooterUndo: "CANCEL",

  // GestioneAgentAIScreen
  GestioneAgentAIAlertErrorAddFile: "Not valid File",
  GestioneAgentAIBreadcrumb1: "Content Management",
  GestioneAgentAIBreadcrumb2: "Create Agent",
  GestioneAgentAIAlertSuccess: "Changes saved successfully.",
  GestioneAgentAIAlertError: "An error occurred while making the changes...",
  GestioneAgentAITitleCreate: "Agent creation",
  GestioneAgentAITitleEdit: "Edit Agent",
  GestioneAgentAIName: "Name",
  GestioneAgentAIGreetingsMessage: "Welcome message",
  GestioneAgentAILLMmodel: "LLM model",
  GestioneAgentAIButtonOpenChangeLanguge: "Change language",
  GestioneAgentAIAgentVoice: "Agent voice",
  GestioneAgentAIGender: "Gender",
  GestioneAgentAIOptionSelect: "Select...",
  GestioneAgentAILang: "Language",
  GestioneAgentAIVoice: "Voice",

  GestioneAgentAIKnowladgeBase: "Knowledge Base",
  GestioneAgentAIKnowladgeBaseString: "Text information to provide",
  GestioneAgentAIAlertLimitDocument: "Maximum 5 files",
  GestioneAgentAIImgDelete: "delete",
  GestioneAgentAIAgentImage: "Agent image",
  GestioneAgentAIImageFile: "Image file:",
  GestioneAgentAIButtonSelect: "SELECT",
  GestioneAgentFlagSizeImage: "Full-size photo",

  GestioneAgentAIButtonSave: "SAVE",
  GestioneAgentAIButtonUndo: "CANCEL",

  // GestioneAgentListScreen
  GestioneAgentListBreadcrumb1: "Agent Management",
  GestioneAgentListPageTitle: "Manage Agent content",
  GestioneAgentListColumnDesc: "Description",
  GestioneAgentListColumnStatus: "Status",
  GestioneAgentListStatusDone: "Active",
  GestioneAgentListStatusError: "Error",
  GestioneAgentListStatusLoading: "In progress",
  GestioneAgentListImgEdit: "edit",
  GestioneAgentListImgDelete: "delete",
  GestioneAgentListImgAdd: "add",
  GestioneAgentListAlertSuccess: "Changes saved successfully.",
  GestioneAgentListAlertError: "An error occurred while making the changes...",
  GestioneAgentListButtonNew: "CREATE AGENT",
  GestioneAgentListDialogTitle: "Delete the selected content?",
  GestioneAgentListDialogConfirm: "YES",
  GestioneAgentListDialogUndo: "NO",

  // GestioneContenutiFolder

  GestioneContenutiFolderBreadcrumb1: "Content Management",
  GestioneContenutiFolderBreadcrumb2: "Create/Edit Folder",
  GestioneContenutiFolderAlertSuccess: "Changes saved successfully.",
  GestioneContenutiFolderAlertError:
    "An error occurred while making the changes...",
  GestioneContenutiFolderMnageFolder: "Folder Management",
  GestioneContenutiFolderDesc: "Description",
  GestioneContenutiFolderFatherFolder: "Parent folder",

  // GestioneSistemaScreen
  GestioneSistemaBreadcrumb1: "System Management",
  GestioneSistemaColumnID: "ID",
  GestioneSistemaColumnKey: "Key",
  GestioneSistemaColumnValue: "Value",
  GestioneSistemaColumnSettingGroup: "Group",
  GestioneSistemaImgEdit: "edit",
  GestioneSistemaImgDelete: "delete",
  GestioneSistemaImgRestore: "restore",
  GestioneSistemaAlertSucess: "Changes saved successfully.",
  GestioneSistemaAlertError: "An error occurred while making the changes...",
  GestioneSistemaTabSetting: "Settings",
  GestioneSistemaTabLang: "Languages",
  GestioneSistemaTitle: "Create or edit system settings",
  GestioneSistemaSubtitle: "Settings",
  GestioneSistemaButtonNew: "CREATE NEW ITEM",
  GestioneSistemaDialogTitle: "Do you want to delete the selected item?",
  GestioneSistemaDialogConfirm: "YES",
  GestioneSistemaDialogUndo: "NO",

  // GestioneLingueScreen

  GestioneLingueBreadcrumb1: "System",
  GestioneLingueBreadcrumb2: "Languages",
  GestioneLingueColumnCodLang: "Language code",
  GestioneLingueColumnDesc: "Description",
  GestioneLingueImgEdit: "edit",
  GestioneLingueDialogSuccess: "Changes saved successfully.",
  GestioneLingueDialogError: "An error occurred while making the changes...",
  GestioneLingueTabSystem: "System",
  GestioneLingueTabLang: "Languages",
  GestioneLingueTitle: "Create or edit a language",
  GestioneLingueSubtitle: "Languages",
  GestioneLingueButtonNew: "CREATE NEW LANGUAGE",

  // GestioneLingueDetailScreen
  GestioneLingueDetailBreadcrumb1: "System",
  GestioneLingueDetailBreadcrumb2: "Language Management",
  GestioneLingueDetailAlertSucess: "Changes saved successfully.",
  GestioneLingueDetailAlertError:
    "An error occurred while making the changes...",
  GestioneLingueDetailTitle: "Language Management",
  GestioneLingueDetailCodLang: "Language code",
  GestioneLingueDetailDesc: "Description",

  // GestioneSistemaDetailScreen
  GestioneSistemaDetailBreadcrumb1: "System Management",
  GestioneSistemaDetailBreadcrumb2: "Create/Edit Setting",
  GestioneSistemaDetailAlertSucess: "Changes saved successfully.",
  GestioneSistemaDetailAlertError:
    "An error occurred while making the changes...",
  GestioneSistemaDetailTitle: "System Setting Management",
  GestioneSistemaDetailId: "ID",
  GestioneSistemaDetailKey: "Key",
  GestioneSistemaDetailValue: "Value",
  GestioneSistemaDetailGroup: "Group",

  //CustomNode
  CustomNodeNewNodeText: "new",
  CustomNodeNewArcText: "new arc",
  CustomNodeImgRestartSession: "Restart Session",
  CustomNodeNewArcImgAdd: "add",
  CustomNodeNewArcImgDuplicate: "duplicate",
  CustomNodeNewArcDelete: "delete",
  CustomNodeNewArcHide: "hide",

  // {selectedLinguaTesto?.CustomNodeNewArcDelete}
  // selectedLinguaTesto?.CustomNodeNewNodeText

  // import { useLingueStore } from "../sistema/storeLingua";

  //  const { selectedLinguaTesto } = useLingueStore(
  //     (state) => state
  //   );
};

export const Lingue = [
  { key: "IT", value: IT },
  { key: "ENG", value: ENG },
  { key: "FR", value: FR },
];
